(() => {
  const updateStoreNavigation = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      let url;
      try { url = new URL(link.href, window.location.origin); } catch (_) { return; }
      const label = String(link.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');

      if (url.hostname === 'htu.miixpro.com' && label === 'user manual') {
        link.href = '/pages/user-manual';
      } else if (url.hostname === 'htu.miixpro.com' && (label === 'firmware update' || label === 'firmware updates')) {
        link.href = '/pages/firmware-updates';
      } else if (url.origin === window.location.origin && url.pathname === '/pages/ks-tracking') {
        link.href = '/pages/shipping-status';
        if (label === 'track kickstarter order' || label === 'track ks order') link.textContent = 'Shipping Status';
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateStoreNavigation, { once: true });
  else updateStoreNavigation();
  document.addEventListener('shopify:section:load', updateStoreNavigation);
})();
